module.exports = __webpack_public_path__ + "img/bumpMap_2048.006b5d91.jpg";